import { IHotsiteRegisterForm, store, updateRegisterForm } from 'store'
import { HotsiteFormMain } from '../..'
import { trans } from 'sharedKernel/i18n'
import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { LoginButton } from '../FormActions/Login'
import { DescriptedLabel, Input, Password } from 'iebt-zing-storybook'
import { passwordAcceptance } from 'components/Password/Rules'
import { FormTitle, PasswordAcceptance  } from './style'
import { applyMaskIfNotEmpty, applyTitleOnError } from 'sharedKernel/handlers'
import { handleFormValidity, handlePasswordAndConfirmPasswordEquality, ifNotEmptyValidatePassword } from '../FormActions/validations'
import { ifNotEmptyValidateEmail, ifNotEmptyValidateMobile, isEmptyField } from '../../validations'
import { DROPDOWN_ACTIVITY, DROPDOWN_MET_WEB, INPUT_MASK_FORMAT } from 'sharedKernel/constants'
import { RegisterActions } from '../FormActions'
import { IFormFieldProperties } from '../../contracts'

export interface ResolverRegisterFormProps {
  registerFormStateProps: IHotsiteRegisterForm
  registerUrl: string
  userType: string
}

export const SimplifiedResolverRegisterForm = ({ registerFormStateProps, registerUrl, userType }): JSX.Element => {
  const registerFormState = { ...registerFormStateProps }

  const passwordAcceptanceDescription = passwordAcceptance()

  const labels = {
    formTitleSimplifiedResolver: trans('Faça parte do TEIA'),
    startupName: trans('Nome da startup'),
    startupPlaceholder: trans('Digite o nome da startup'),
    titleMessage: trans('Preencha este campo'),
    email: trans('E-mail'),
    emailPlaceholder: trans('Digite seu e-mail'),
    contactName: trans('Nome do representante'),
    namePlaceholder: trans('Digite seu nome completo'),
    phone: trans('Telefone'),
    phonePlaceholder: trans('Digite seu telefone'),
    metWeb: trans('Como conheceu o Espaço Teia?'),
    activity: trans('Qual é a Vertical/Setor de atuação?'),
    password: trans('Senha'),
    passwordPlaceholder: trans('Digite uma senha'),
    passwordConfirmation: trans('Confirmação de senha'),
    passwordConfirmationPlaceholder: trans('Confirme sua senha'),
    passwordAcceptance: trans('Sua senha deve conter no mínimo 8 caracteres, uma letra maiúscula, uma letra minúscula, um número, um caracter especial')
  }

  const getInput = (field: Field): JSX.Element => {
    if (field.type === 'select') {
      return (
        <>
          <DescriptedLabel>{`${field.label}`}</DescriptedLabel>{field.isRequired && <span style={{ color: 'red' }}> *</span>}
          <Form.Select
            id={field.id}
            value={field.value}
            onChange={field.onChange}
            isInvalid={field.isInvalid}
            onBlur={field.onBlur}
            disabled={field.disabled}
          >
            {field.options?.map((option, index) => {
              return (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              )
            })}
          </Form.Select>
        </>
      )
    }
    if (field.type === 'password') {
          return (
            <Password
              id={field.id}
              isRequired={field.isRequired}
              title={field.title}
              label={`${field.label}`}
              description={passwordAcceptanceDescription}
              placeholder={field.placeholder}
              value={field.value}
              isInvalid={field.isInvalid}
              notValidFieldMessage={field.notValidFieldMessage}
              onChange={field.onChange}
              onBlur={field.onBlur}
            ></Password>
          )
        }
    if (field.type === 'number') {
        return (
        <Input
            id={field.id}
            maxLength={field.maxLength}
            isRequired={field.isRequired}
            title={field.title}
            label={field.label}
            placeholder={field.placeholder}
            value={field.value}
            mask={field.mask}
            code={field.code}
            isInvalid={field.isInvalid}
            notValidFieldMessage={field.notValidFieldMessage}
            onChange={(event) => { field.onChange(event) }}
            onBlur={field.onBlur}
            disabled={field.disabled}
            type='number'
        />
        )
    }

    return (
      <Input
        id={field.id}
        maxLength={field.maxLength}
        isRequired={field.isRequired}
        title={field.title}
        label={field.label}
        placeholder={field.placeholder}
        value={field.value}
        mask={field.mask}
        code={field.code}
        isInvalid={field.isInvalid}
        notValidFieldMessage={field.notValidFieldMessage}
        onChange={(event) => { field.onChange(event) }}
        onBlur={field.onBlur}
        disabled={field.disabled}
      />
    )
  }

  const passwordAndConfirmPasswordValidations = (currentPassword: IFormFieldProperties): boolean => {
      if (ifNotEmptyValidatePassword(currentPassword)) {
        return handlePasswordAndConfirmPasswordEquality(
          registerFormState?.form.password,
          registerFormState?.form.confirmPassword
        )
      }
      return false
    }

  const handleChange = (value, key): void => {
    registerFormState.form[key].value = value
    store.dispatch(updateRegisterForm(handleFormValidity(registerFormState)))
  }

  const simplifiedResolverForm: ISimplifiedResolverForm = {
    rows: [
      {
        cols: [
          {
            fields: [
              {
                id: 'startupName',
                placeholder: labels.namePlaceholder,
                maxLength: 60,
                isRequired: registerFormState?.form.startupName?.isRequired,
                title: applyTitleOnError(registerFormState?.form.startupName.message, labels.titleMessage),
                label: labels.startupName,
                value: registerFormState?.form.startupName?.value,
                onChange: (event) => {
                  handleChange(event.target.value, 'startupName')
                },
                onBlur() {
                  if (registerFormState.form.startupName != null) {
                    isEmptyField(registerFormState.form.startupName)
                  }
                  store.dispatch(updateRegisterForm(handleFormValidity(registerFormState)))
                }
              }
            ]
          }
        ]
      },
      {
        cols: [
            {
                fields: [
                    {
                        id: 'contactName',
                        maxLength: 60,
                        isRequired: registerFormState?.form.contactName?.isRequired,
                        title: applyTitleOnError(registerFormState?.form.contactName.message, labels.titleMessage),
                        label: labels.contactName,
                        placeholder: labels.namePlaceholder,
                        value: registerFormState?.form.contactName?.value,
                        isInvalid: registerFormState?.form.contactName?.isInvalid,
                        notValidFieldMessage: registerFormState?.form.contactName?.message,
                        onChange: (event) => {
                          handleChange(event.target.value, 'contactName')
                        },
                        onBlur() {
                          isEmptyField(registerFormState.form.contactName)
                          store.dispatch(updateRegisterForm(handleFormValidity(registerFormState)))
                        }
                    }
                ]
            }
        ]
      },
      {
        cols: [
            {
                fields: [
                    {
                      id: 'email',
                      maxLength: 60,
                      isRequired: registerFormState?.form.email?.isRequired,
                      title: applyTitleOnError(registerFormState?.form.email.message, labels.titleMessage),
                      label: labels.email,
                      placeholder: labels.emailPlaceholder,
                      value: registerFormState?.form.email?.value,
                      isInvalid: registerFormState?.form.email?.isInvalid,
                      notValidFieldMessage: registerFormState?.form.email?.message,
                      onChange: (event) => {
                        handleChange(event.target.value.trim(), 'email')
                      },
                      onBlur() {
                        ifNotEmptyValidateEmail(registerFormState?.form.email)
                        store.dispatch(updateRegisterForm(handleFormValidity(registerFormState)))
                      }
                    }
                ]
            }
        ]
      },
      {
        cols: [
            {
                fields: [
                    {
                        id: 'phone',
                        isRequired: registerFormState?.form.phone?.isRequired,
                        title: applyTitleOnError(registerFormState?.form.phone.message, labels.titleMessage),
                        label: labels.phone,
                        placeholder: labels.phonePlaceholder,
                        value: registerFormState?.form.phone?.value,
                        code: 'masked',
                        mask: applyMaskIfNotEmpty(registerFormState?.form.phone.value, INPUT_MASK_FORMAT.MOBILE),
                        isInvalid: registerFormState?.form.phone?.isInvalid,
                        notValidFieldMessage: registerFormState?.form.phone?.message,
                        onChange: (event) => {
                          handleChange(event.target.value, 'phone')
                        },
                        onBlur() {
                          ifNotEmptyValidateMobile(registerFormState?.form.phone)
                          store.dispatch(updateRegisterForm(handleFormValidity(registerFormState)))
                        }
                    }
                ]
            }
        ]
      },
      {
        cols: [
            {
                fields: [
                    {
                        id: 'metWeb',
                        isRequired: registerFormState?.form.metWeb.isRequired,
                        label: labels.metWeb,
                        value: registerFormState?.form.metWeb.value,
                        isInvalid: registerFormState?.form.metWeb?.isInvalid,
                        onChange: (event) => {
                          handleChange(event.target.value, 'metWeb')
                          isEmptyField(registerFormState.form.metWeb)
                        },
                        onBlur: () => {
                          isEmptyField(registerFormState.form.metWeb)
                        },
                        options: DROPDOWN_MET_WEB,
                        type: 'select'
                    }
                ]
            }
        ]
      },
      {
        cols: [
            {
                fields: [
                    {
                        id: 'activity',
                        isRequired: registerFormState?.form.activity?.isRequired,
                        label: labels.activity,
                        value: registerFormState?.form.activity?.value,
                        isInvalid: registerFormState?.form.activity?.isInvalid,
                        onChange: (event) => {
                          handleChange(event.target.value, 'activity')
                          isEmptyField(registerFormState.form.activity)
                        },
                        onBlur: () => {
                          isEmptyField(registerFormState.form.activity)
                        },
                        options: DROPDOWN_ACTIVITY,
                        type: 'select'
                    }
                ]
            }
        ]
      },
      {
        cols: [
          {
            fields: [
              {
                id: 'password',
                isRequired: registerFormState?.form.password?.isRequired,
                title: applyTitleOnError(registerFormState?.form.password.message, labels.titleMessage),
                label: labels.password,
                placeholder: labels.passwordPlaceholder,
                value: registerFormState?.form.password?.value,
                type: 'password',
                isInvalid: registerFormState?.form.password?.isInvalid,
                notValidFieldMessage: registerFormState?.form.password?.message,
                onChange: (event) => {
                  handleChange(event.target.value.trim(), 'password')
                },
                onBlur() {
                  passwordAndConfirmPasswordValidations(registerFormState?.form.password)
                  store.dispatch(updateRegisterForm(handleFormValidity(registerFormState)))
                }
              }
            ]
          }
        ]
      },
      {
        cols: [
          {
            fields: [
              {
                id: 'confirmPassword',
                isRequired: registerFormState?.form.confirmPassword?.isRequired,
                title: applyTitleOnError(registerFormState?.form.confirmPassword.message, labels.titleMessage),
                label: labels.passwordConfirmation,
                placeholder: labels.passwordConfirmationPlaceholder,
                value: registerFormState?.form.confirmPassword?.value,
                type: 'password',
                isInvalid: registerFormState?.form.confirmPassword?.isInvalid,
                notValidFieldMessage: registerFormState?.form.confirmPassword?.message,
                onChange: (event) => {
                  handleChange(event.target.value.trim(), 'confirmPassword')
                },
                onBlur() {
                  passwordAndConfirmPasswordValidations(registerFormState?.form.confirmPassword)
                  store.dispatch(updateRegisterForm(handleFormValidity(registerFormState)))
                }
              }
            ]
          }
        ]
      }
    ]
  }


  return (
    <HotsiteFormMain formTitle={labels.formTitleSimplifiedResolver} >
      {simplifiedResolverForm.rows.map((row, rowIndex) => (
        <Row key={rowIndex} className='my-2'>
          {row.cols.map((col, colIndex) => (
            <Col lg={true} key={colIndex}>
              {col.fields.map((field, fieldIndex) => (
                <div key={fieldIndex} className='mb-2'>
                    {getInput(field)}
                </div>
              ))}
            </Col>
          ))}
        </Row>
      ))}
      <div className='px-2 mt-2'>
        <Row>
          <PasswordAcceptance isInvalid={registerFormState?.form.password.isInvalid}>{labels.passwordAcceptance}</PasswordAcceptance>
        </Row>
        <RegisterActions isSimplified={true} registerUrl={registerUrl} userType={userType} registerFormState={registerFormState} registerType='Resolver' />
      </div>
      <hr className='mt-4' />
      <LoginButton />
    </HotsiteFormMain>
  )
}
